import { useQuery } from '@tanstack/react-query';
import { getAgentClient } from '@/lib/api-clients';
import { queryKeys } from '@/lib/query-keys';

/**
 * Hook to fetch all agents for the org.
 */
export function useAgents() {
  return useQuery({
    queryKey: queryKeys.agents.list(),
    queryFn: () => getAgentClient().getAll(),
  });
}
